import Compare from "./Compare";

export * from "./Compare";

export default Compare;
